module.exports = __webpack_public_path__ + "c05ad06e23e7a81018fdc9a93ba7a9f6.pdf";